import { render, staticRenderFns } from "./DebugBar.vue?vue&type=template&id=49bc28f0&"
import script from "./DebugBar.vue?vue&type=script&lang=js&"
export * from "./DebugBar.vue?vue&type=script&lang=js&"
import style0 from "./DebugBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bc28f0')) {
      api.createRecord('49bc28f0', component.options)
    } else {
      api.reload('49bc28f0', component.options)
    }
    module.hot.accept("./DebugBar.vue?vue&type=template&id=49bc28f0&", function () {
      api.rerender('49bc28f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DebugBar.vue"
export default component.exports